function init() {
    var snapId = -1; //
    /**
     * Erstellen
     */
    $('.snap-new .ok').click(function(event) {
        // Snapshot erzeugen
        $('#loader').show();
        $.ajax({
            type: "POST",
            url: '/Handler/HvD/Snapshot',
            data: {
                data: {
                    type: 'new',
                    title: $('#snap_name').val(),
                    description: $('#snap_description').val()
                }
            }
        }).done(function(data) {
            if (data == 'ok') {
                $('#loader').hide();
                location.reload();
            } else {
                alert(data);
                $('#loader').hide();
            }
        });
    });

    /**
     * Wieder herstellen
     */
    var dlgRestoreSnap = $('#dlgRestoreSnap').dialog({
        autoOpen: false,
        modal: true,
        width: 450,
        buttons: [{
                text: "Abbrechen",
                class: "cancel",
                click: function(event) {
                    $(this).dialog("close");
                }
            },
            {
                text: "Ok",
                class: "ok",
                click: function(event) {
                    $.ajax({
                        type: "POST",
                        url: '/Handler/HvD/Snapshot',
                        data: {
                            data: {
                                type: 'restore',
                                id: snapId
                            }
                        }
                    }).done(function(data) {
                        if (data == 'ok') {
                            $(dlgRestoreSnap).find('.content').html('Der Snapshot wurde erfolgreich wieder hergestellt');
                            location.reload();
                        }
                    });
                }
            }

        ]
    });
    $(dlgRestoreSnap).find('.cancel').click(function(event) {
        dlgRestoreSnap.dialog("close");
        $(dlgRestoreSnap).find('.ok').off('click');
    });
    $('i.restore').click(function(event) {
        var snapId = $(this).attr('data-value');
        dlgRestoreSnap.dialog("open");

    });


    /**
     * Löschen
     */
    var dlgDeleteSnap = $('#dlgDelSnap').dialog({
        autoOpen: false,
        modal: true,
        buttons: [{
                text: "Abbrechen",
                class: "cancel",
                click: function(event) {
                    $(this).dialog("close");
                }
            }, {
                text: "Löschen",
                class: "ok",
                click: function(event) {
                    $.ajax({
                        type: "POST",
                        url: '/Handler/HvD/Snapshot',
                        data: {
                            data: {
                                type: 'del',
                                id: snapId
                            }
                        }
                    }).done(function(data) {
                        if (data == 'ok') {
                            $(dlgDeleteSnap).find('.content').html('Der Snapshot wurde erfolgreich gelöscht');
                            location.reload();
                        }
                    });
                    $(dlgDeleteSnap).find('.ok').off('click');
                }
            }

        ]
    });
    $(dlgDeleteSnap).find('.cancel').click(function(event) {
        dlgDeleteSnap.dialog("close");
        $(dlgDeleteSnap).find('.ok').off('click');
    });
    $('i.del').click(function(event) {
        snapId = $(this).attr('data-value');
        dlgDeleteSnap.dialog("open");
    });
}
init();
